// OhneFilterHinweis — Leerzustand „Keine Treffer mit den gesetzten Filtern —
// ohne Filter N Ergebnisse anzeigen" (Vorgänge seit 21.09.2026, Kontaktliste
// seit 02.10.2026). Die Zahl liefert `useOhneFilterProbe`.
//
// Die Zahl ist Teil des Angebots: „Ohne Filter anzeigen" allein ließe offen,
// ob sich der Klick lohnt.

import * as React from "react";

export function OhneFilterHinweis({
  anzahl,
  onOhneFilter,
  text = "Keine Treffer mit den gesetzten Filtern.",
  knopfText,
}: {
  /** Treffer ohne Filter (> 0, sonst rendert die Komponente nichts). */
  anzahl: number | null;
  onOhneFilter: () => void;
  /** Satz vor dem Knopf. */
  text?: React.ReactNode;
  /** Beschriftung des Knopfs; Standard „Ohne Filter: N Ergebnisse anzeigen". */
  knopfText?: (anzahl: number) => React.ReactNode;
}) {
  if (!anzahl || anzahl <= 0) return null;
  return (
    <span className="ohnefilter-hinweis">
      {text}{" "}
      <button type="button" className="vg-ohnefilter" onClick={onOhneFilter}>
        {knopfText
          ? knopfText(anzahl)
          : `Ohne Filter: ${anzahl} ${anzahl === 1 ? "Ergebnis" : "Ergebnisse"} anzeigen`}
      </button>
    </span>
  );
}
